<template>
	<v-dialog v-model="showDialog" :max-width="modalWidth" persistent>
		<v-card>
			<v-card-text class="text-center"
				>{{
					'Are you sure you want to clone ' +
					message +
					'?' +
					'\nPlease choose a name for the new item!'
				}}

				<v-text-field label="Name" v-model="name"> </v-text-field>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-btn @click.stop="onCancel" color="error">{{ 'No' }}</v-btn>
				<v-spacer />
				<v-btn @click.stop="onConfirm" color="primary">{{
					'Yes'
				}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	Name: 'CloneModalDialog',
	data() {
		return { name: '' };
	},
	props: {
		showDialog: Boolean,
		message: String,
		modalWidth: String,
	},
	methods: {
		onCancel() {
			this.$emit('cancel');
		},
		onConfirm() {
			this.$emit('confirm', this.name);
		},
	},
};
</script>
